// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh3[data-v-469af010] {\r\n  margin: 40px 0 0;\n}\nul[data-v-469af010] {\r\n  list-style-type: none;\r\n  padding: 0;\n}\nli[data-v-469af010] {\r\n  display: inline-block;\r\n  margin: 0 10px;\n}\na[data-v-469af010] {\r\n  color: #42b983;\n}\r\n", ""]);
// Exports
module.exports = exports;
